import regions from '../config/regions'

export default {
	namespaced: true,
	state: {
		list: []
	},
	getters: {

	},
	actions: {
		async getList({ commit }) {
			commit('set', { type: 'list', value: regions.regions })
		}
	},
	mutations: {
		set(state, { type, value }) {
			state[type] = value
		}
	}
}
